<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container d-flex align-items-center">
        <div class="col px-0">
          <div class="row justify-content-center align-items-center mt-5">
            <div class="col-lg-7 text-center pt-lg">
              <h1 class="text-white mt-4 mb-5">Ops! 404 Page Not Found</h1>
              <p class="lead text-white mt-4 mb-5">
                A página que você tentou acessar não existe ou está fora do ar!
              </p>
              <div class="text-center">
                <base-button
                  type="primary"
                  class="my-4"
                  @click="$router.push('/')"
                  >Voltar</base-button
                >
              </div>
            </div>
          </div>
          <div
            class="row align-items-center justify-content-around stars-and-coded"
          ></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "page-not-found",
};
</script>

<style>
</style>